import React, { Component } from "react";
import axios from "axios";

export class Step2Services extends Component {
  constructor(props) {
    super(props);

    this.state = {
      services: props.formData.services || [],
      serviceList: [],
      loading: true,
      error: "",
    };
  }

  componentDidMount() {
    this.loadServices();
  }

  loadServices = () => {
    axios
      .post("https://idealtechnoride.in/api/business_service")
      .then((res) => {
        this.setState({
          serviceList: res.data,
          loading: false,
        });
      })
      .catch((err) => {
        console.error(err);

        this.setState({
          loading: false,
          error: "Unable to load services.",
        });
      });
  };

  handleCheckbox = (e) => {
    const { value, checked } = e.target;

    let services = [...this.state.services];

    if (checked) {
      if (!services.includes(value)) {
        services.push(value);
      }
    } else {
      services = services.filter((item) => item !== value);
    }

    this.setState({
      services,
      error: "",
    });
  };

  handleNext = () => {
    const { services } = this.state;

    if (services.length === 0) {
      this.setState({
        error: "Please select at least one service.",
      });
      return;
    }

    this.props.updateFormData({
      services,
    });

    if (this.props.buildBusinessSteps) {
      this.props.buildBusinessSteps(services);
    }

    this.props.nextStep();
  };

  render() {
    const { loading, serviceList, services, error } = this.state;

    return (
      <div className="container py-4">
        <div className="card shadow border-0">

          <div className="card-header bg-primary text-white">
            <h3 className="mb-0">
              Step 2 : Select Required Services
            </h3>
          </div>

          <div className="card-body">

            <p className="text-muted mb-4">
              Select one or more services required for your business.
            </p>

            {loading ? (
              <div className="text-center py-5">
                <h5>Loading Services...</h5>
              </div>
            ) : (
              <div className="row">

                {serviceList.map((service) => (
                  <div
                    className="col-md-6 mb-3"
                    key={service.business_service_id}
                  >
                    <div className="form-check">

                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`service_${service.business_service_id}`}
                        value={service.business_service_name}
                        checked={services.includes(
                          service.business_service_name
                        )}
                        onChange={this.handleCheckbox}
                      />

                      <label
                        className="form-check-label"
                        htmlFor={`service_${service.business_service_id}`}
                      >
                        {service.business_service_name}
                      </label>

                    </div>

                  </div>
                ))}

              </div>
            )}

            {error && (
              <div className="alert alert-danger mt-3">
                {error}
              </div>
            )}

            <hr />

            <div className="d-flex justify-content-between">

              <button
                className="btn btn-outline-secondary"
                onClick={this.props.prevStep}
              >
                Previous
              </button>

              <button
                className="btn btn-primary"
                onClick={this.handleNext}
              >
                Next
              </button>

            </div>

          </div>

        </div>
      </div>
    );
  }
}

export default Step2Services;